export default __webpack_public_path__ + "static/media/notice-board.e0c3c787.png";